import type { SxProps, Theme } from "@mui/material/styles";

export const mapAreaTextLinkButtonSx: SxProps<Theme> = {
  textTransform: "none",
  fontFamily: '"Gotham", sans-serif',
  fontWeight: 350,
  fontSize: 16,
  lineHeight: "24px",
  letterSpacing: 0,
  textAlign: "center",
  verticalAlign: "middle",
  textDecoration: "underline",
  textDecorationStyle: "solid",
  textUnderlineOffset: 1,
  textDecorationThickness: "1px",
  WebkitTextDecorationThickness: "1px",
  minWidth: "auto",
  padding: "10px 12px",
  color: "primary.main",
  "&:hover": {
    backgroundColor: "transparent",
    boxShadow: "none",
    color: "primary.main",
    textDecoration: "underline",
    textDecorationStyle: "solid",
    textUnderlineOffset: 1,
    textDecorationThickness: "1px",
    WebkitTextDecorationThickness: "1px",
  },
  "&:active": {
    textDecoration: "underline",
    textDecorationStyle: "solid",
    textUnderlineOffset: 1,
    textDecorationThickness: "1px",
    WebkitTextDecorationThickness: "1px",
  },
  "&.Mui-disabled:hover": {
    backgroundColor: "transparent",
    color: "#D8DBE0",
    WebkitTextFillColor: "#D8DBE0",
    textDecoration: "underline",
    textDecorationStyle: "solid",
    textUnderlineOffset: 1,
    textDecorationThickness: "1px",
    WebkitTextDecorationThickness: "1px",
  },
  "&.Mui-disabled": {
    opacity: 1,
    color: "#D8DBE0",
    WebkitTextFillColor: "#D8DBE0",
    fontFamily: '"Gotham", sans-serif',
    fontWeight: 350,
    fontSize: 16,
    lineHeight: "24px",
    textDecoration: "underline",
    textDecorationStyle: "solid",
    textUnderlineOffset: 1,
    textDecorationThickness: "1px",
    WebkitTextDecorationThickness: "1px",
  },
};
